export default __webpack_public_path__ + "static/media/import.d119e432.svg";